import axios from "axios";
import authHeader from "@/services/auth-header";

class DocumentTypeService {
  getAll() {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/api/BytePro/DocumentType/All`, {
        headers: authHeader(),
      })
      .then((response) => {
        return response;
      });
  }
}

export default new DocumentTypeService();
